export function createReportLoadConfig (embedInfo, tokenType) {
  return {
    type: 'report',
    tokenType: tokenType,
    accessToken: embedInfo.embedToken,

    // Use other embed report config based on the requirement. We have used the first one for demo purpose
    embedUrl: embedInfo.embedUrl,
    pageView: 'ActualSize',
    settings: {
      filterPaneEnabled: false,
      navContentPaneEnabled: false,
      panes: {
        pageNavigation: {
          position: 1
        }
      }
    }
  }
}
